import {
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  Popover,
} from "@material-ui/core";
import React from "react";
import { AppNotification } from "../../models/Notification/AppNotification";
import { NotificationService } from "../../services/NotificationService";
import useStyles from "./NotificationBar.css";

interface NotificationBarMeta {
  anchorEl: HTMLButtonElement | null;
  setAnchorEl: any;
  notificationList: Array<AppNotification>;
  setNofityRequestNumber:any;
  clickOnItem:any
}

export default function NotificationBar(props: NotificationBarMeta) {
  const classes = useStyles();
  const { anchorEl, setAnchorEl, notificationList, setNofityRequestNumber, clickOnItem } = props;
  const open = Boolean(anchorEl);
  const id = open ? "notifcation-popover" : undefined;

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNotificationClick = (listItem:AppNotification) => {
    setNofityRequestNumber(listItem.requestNo);
    setAnchorEl(null);
    clickOnItem(listItem);
  };

  return (
    <div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div>
          <List className={classes.root}>
            {notificationList.map((row, index) => (
              <div className={classes.notiWrapper}>
                <ListItem key={row.id} alignItems="flex-start" button onClick={(e) => handleNotificationClick(row)}>
                  <Grid container direction="column">
                    <ListItemText primary={row.message} />
                    <ListItemText primary={row.createdDate} className={classes.txtClrGray}/>
                  </Grid>
                </ListItem>
                <Divider variant="inset" component="li" />
              </div>
            ))}
          </List>
        </div>
      </Popover>
    </div>
  );
}
